import { Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { BadgeVariant, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const variantClassMap: Record<BadgeVariant, string> = {
    adjuvant: styles.adjuvant,
    danger: styles.danger,
    default: '',
    dicamba: styles.dicamba,
    driftRetardant: styles.driftRetardant,
    fungicide: styles.fungicide,
    growth: styles.growth,
    herbicide: styles.herbicide,
    insecticide: styles.insecticide,
    surfactant: styles.surfactant,
    warning: styles.warning,
    waterConditioner: styles.waterConditioner
};

const Badge: FunctionComponent<Props> = ({
    className = '',
    testId = TEST_ID,
    text,
    variant = 'default'
}) => {
    const variantClass = variantClassMap[variant];

    return (
        <Wrapper className={`${styles.badge} ${variantClass} ${className}`} testId={testId}>
            {text}
        </Wrapper>
    );
};

export default Badge;
